import { authorized, isAdminUser } from '../../../utils/loaders.ts';
import { ADMIN_USER_LIST_PATH } from './paths.ts';

export default [
    {
        handle: {
            title: ['admin:userListPage.documentTitle'],
        },
        path: ADMIN_USER_LIST_PATH,
        lazy: async () => ({ Component: (await import('./pages/UserListPage.tsx')).default }),
        loader: authorized(isAdminUser),
    },
];
